import { Link as RouterLink } from 'react-router-dom';
import styled, { css } from 'styled-components';

import {
    designColor,
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledMedia,
    styledReset,
} from '@pkg/primitives';

import { tokens } from './CloseAction.tokens';

interface WrapperProps {
    $back?: boolean;
}

export const Wrapper = styled.div<WrapperProps>`
    ${styledReset.borderBox};

    --sheet-close-action-border-color: rgb(255, 255, 255, 0.2);
    --sheet-close-action-size: ${tokens.size.mobile}px;
    --sheet-close-icon-size: ${tokens.iconSize.mobile}px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        --sheet-close-action-size: ${tokens.size.desktop}px;
        --sheet-close-icon-size: ${tokens.iconSize.desktop}px;
    }

    ${({ $back }) =>
        $back &&
        css`
            --sheet-close-action-border-color: transparent;
        `};
`;

const actionBase = css`
    display: grid;
    place-items: center;
    place-content: center;
    width: var(--sheet-close-action-size);
    height: var(--sheet-close-action-size);
    background-color: rgb(255, 255, 255, 0.04);
    backdrop-filter: blur(2px);
    border: 2px solid var(--sheet-close-action-border-color);
    border-radius: 999px;
    outline: 2px solid transparent !important;
    outline-offset: 2px;
    transition-property: opacity, background-color, border-color, outline-color;
    transition-duration: ${duration.normal}ms;
    transition-timing-function: ${easing.cubic};

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.1);
    }
`;

export const Action = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    ${actionBase};

    &:disabled {
        ${styledInteraction.interactionDisable};
        opacity: 0.8;
    }

    &:focus-visible {
        outline-color: ${designColor.brandPurple} !important;
    }
`;

export const Link = styled(RouterLink)`
    ${styledReset.link};
    ${actionBase};
`;

export const IconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    width: var(--sheet-close-icon-size);
    height: var(--sheet-close-icon-size);
`;
